export enum RegexEnum {
  url_check = "^(http://www.|https://www.|http://|https://)[a-z0-9]+([-.]{1}[a-z0-9]+)*.[a-z]{2,5}(:[0-9]{1,5})?(/.*)?$",
  name = "^[a-zA-Z ]*$",
  phone = "^[0-9]*$",
  numeric = "^[0-9]*$",
  numeric_dot = "^([0-9]+(.[0-9]+)?)",
  alpha_spaces = "^[a-zA-Z ]+$",
  alpha_numeric = "^[A-Z0-9]+$",
  alpha_numeric_no_space_at_begin = "^[^-s][a-zA-Z0-9_s-]+$",
  alpha_numeric_spaces = "^[A-Z0-9 ]+$",
  alpha_numeric_spaces_underscore = "^[0-9a-zA-Z ]([_]*[0-9a-zA-Z])+$",
  alpha_numeric_spaces_no_white = "^[A-Z0-9]+( [A-Z0-9]+)*$",
  alpha_spaces_no_white = "^[A-Z]+( [A-Z]+)*$",
  email = "^([0-9a-zA-Z]([-_\\.]*[0-9a-zA-Z]+)*)" +
    "@([0-9a-zA-Z]([-_\\.]*[0-9a-zA-Z]+)*)[\\.]([a-zA-Z]{2,9})+$",
  mobile = "^[0-9]{9,11}$",
  url = "(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?",
  password_validation = "^(?!.* )(?=.*?[A-Z])(?=.*?[a-z]).{6,30}$",
  siret_number = "^([0-9]{9})$|(^[0-9]{14})$",
  passwordValidation = "^(?=.{8,15})(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^!&*+=~`*]).*$",
  phonenumber = "^[0-9]{10}$",
  two_dasimal_number = "^(\\d+(\\.\\d{1,2})?)?$"
}
